import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import '../../../../../Assets/EnsembleStyles/ChangeLimits.css';

export default class ChangeLimits extends Component {
    render() {
        return (
            <div className="ChangeLimits_Modal">
                <h4 className="Modal_form_title">Clear All Normal Hours Confirmation</h4>
                <p  className="">You are about to delete all the normal hours. Do you want to continue? Click Yes to delete normal hours or click No to keep them.</p> 
               
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button className="btn-success btn-md ChangeLimits_Applybtn "   onClick={ this.props.ClearAllDays }> Yes </Button>
                            <Button className="btn-gray btn-md ChangeLimits_Cancelbtn"   onClick={this.props.toggle} type="submit" >No</Button>
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}



